import React from 'react';
import styles from './rotations.module.scss';
import { RotationsTabs } from './rotation-list/tabs-rotations-list.component';
import { RotationContent } from './rotation-content/rotation-content.component';
import classNames from 'classnames';
import { RotationsProvider, useRotationsContext } from './rotations-context';
import { Loader } from 'src/components/core';

const RotationsPage = () => {
  return (
    <RotationsProvider>
      <RotationsPageComponent />
    </RotationsProvider>
  );
};

const RotationsPageComponent = () => {
  const { loading } = useRotationsContext();
  return (
    <div className={loading ? styles.loading : classNames(styles.root, 'new-design-system')}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <RotationsTabs />
          <RotationContent />
        </>
      )}
    </div>
  );
};

export { RotationsPage };
